module.exports = __webpack_public_path__ + "static/media/loader.a5ff6e4c.svg";